export default __webpack_public_path__ + "static/media/img-doctor.46afae7d.jpg";